<template>
  <div class="rounded border-[1px] border-[#E0E0E0] p-[18px] mx-[18px]">
    <div class="flex flex-wrap gap-[8px] items-center mb-[16px]">
      <b-avatar
        :src="submissionDetail.partner_logo_url"
        :alt="submissionDetail.partner_owner"
      />
      <div>
        <h3
          class="text-[14px] text-black font-semibold w-full sm:w-auto mb-0"
          :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[20px] !w-[180px]': isOnLoading }"
        >
          {{ submissionDetail.partner_name }}
        </h3>
        <p
          class="text-sm text-gray-500 mb-0"
          :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[16px] mt-[2px] !w-[150px]': isOnLoading }"
        >
          {{ submissionDetail.partner_city }}
        </p>
      </div>
    </div>
    <div class="[&>div]:flex [&>div]:flex-wrap [&>div]:gap-[8px] [&>div]:items-center [&>div]:mb-[4px] text-black [&_p]:mb-0">
      <div>
        <p class="w-[100px]">
          Owner
        </p>
        <p
          class="flex items-center gap-[4px]"
        ><span>:</span> <span
          :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[20px] !w-[140px]': isOnLoading }"
        >{{ submissionDetail.partner_owner }}</span></p>
      </div>
      <div>
        <p class="w-[100px]">
          Email
        </p>
        <p
          class="flex items-center gap-[4px]"
        ><span>:</span> <span
          :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[20px] !w-[200px]': isOnLoading }"
        >{{ submissionDetail.partner_email }}</span></p>
      </div>
      <div>
        <p class="w-[100px]">
          Status
        </p>
        <p
          class="flex items-center gap-[4px]"
        >
          <span>:</span> <span
            :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[20px] !w-[190px]': isOnLoading }"
          ><StorageRequestStatusCell
            v-if="!isOnLoading"
            :status="submissionDetail.status"
          /></span>
        </p>
      </div>
      <div>
        <p
          class="w-[100px]"
        >
          Produk
        </p>
        <p
          class="flex items-center gap-[4px]"
        ><span>:</span> <span
          :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[20px] !w-[100px]': isOnLoading }"
        >{{ submissionDetail.product_total }}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import StorageRequestStatusCell from '../StorageRequestStatusCell.vue'

export default {
  name: 'PartnerProfile',
  components: {
    StorageRequestStatusCell,
  },
  props: {
    isOnLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    submissionDetail: {
      type: Object,
      required: false,
      default: () => ({
        partner_logo_url: '',
        partner_owner: '',
        partner_city: '',
        partner_email: '',
        status: '',
        product_total: '',
      }),
    },
  },
}
</script>
